export * from "./auth";
export * from "./catalog";
export * from "./checkout";
export * from "./magazine";
export * from "./main";
export * from "./static-pages";
export * from "./brands";
export * from "./shops";
export { getMenu } from "./menu";
export * from "./pages";
export * from "./address";
export * from "./fallback";
